import { all, put, take } from 'redux-saga/effects';

import { PIPELINE__NOTE } from 'PipeRouter';

import autoSave from './autoSave';
import create from './create';
import delete_ from './delete';
import toggle from './toggle';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data }} = yield take(PIPELINE__NOTE);

    yield put({ type: cmd, data });
  }
}

export default function*() {
  yield all([
    pipeline(),
    autoSave(),
    create(),
    delete_(),
    toggle()
  ]);
}
